import mailchimp from "./mailchimp";

export default function () {
  mailchimp("#mc-embedded-subscribe-form-interstitial");

  let $emailInterstitial = $(".js-email-interstitial");
  let $urgentInterstitial = $(".js-urgent-interstitial");

  // Urgent interstitial code: once this is clicked away, it can be reactivated by changing Unique ID
  if (localStorage.getItem("interstitialClosed") === $urgentInterstitial.data("id")) {
    $urgentInterstitial.remove();
  } else {
    setTimeout(() => {
      $urgentInterstitial.modal("show");
      $urgentInterstitial.on("hidden.bs.modal", () => {
        $urgentInterstitial.modal("hide");
        $urgentInterstitial.remove();
        // localStorage.setItem("interstitialEmailSeen", "true");
        localStorage.setItem("interstitialClosed", $urgentInterstitial.data("id"));
      });
    }, 100);
  }

  // Email interstitial code: once this is clicked away, it's gone for good
  if (localStorage.getItem("interstitialEmailSeen") === "true") {
    $emailInterstitial.remove();
  } else {
    setTimeout(() => {
      $emailInterstitial.modal("show");
      $emailInterstitial.on("hidden.bs.modal", () => {
        $emailInterstitial.modal("hide");
        $emailInterstitial.remove();
        localStorage.setItem("interstitialEmailSeen", "true");
      });
    }, 100);
  }
}
